import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function useDirection() {
  const { i18n } = useTranslation();
  const prevLangRef = useRef(i18n.language);
  const isFirstMountRef = useRef(true);

  useEffect(() => {
    // CRITICAL FIX: Only update if language actually changed
    // This prevents unnecessary DOM manipulations on every render
    if (prevLangRef.current === i18n.language && !isFirstMountRef.current) {
      return;
    }

    prevLangRef.current = i18n.language;
    isFirstMountRef.current = false;
    const dir = ["ar", "fa"].includes(i18n.language) ? "rtl" : "ltr";

    // CRITICAL FIX: Update HTML attributes safely
    // This prevents hydration mismatches and React errors
    const updateHtmlAttributes = () => {
      if (typeof document !== "undefined" && document.documentElement) {
        document.documentElement.dir = dir;
        document.documentElement.lang = i18n.language;
        // Add prefix for Open Graph if needed
        document.documentElement.setAttribute(
          "prefix",
          "og: https://ogp.me/ns#",
        );

        if (dir === "rtl") {
          document.documentElement.classList.add("rtl");
          document.documentElement.classList.remove("ltr");
        } else {
          document.documentElement.classList.add("ltr");
          document.documentElement.classList.remove("rtl");
        }
      }
    };

    // On first mount, update immediately to prevent hydration issues
    // For subsequent changes, use RAF to batch updates and prevent blocking
    if (isFirstMountRef.current) {
      updateHtmlAttributes();
    } else {
      requestAnimationFrame(updateHtmlAttributes);
    }
  }, [i18n.language]);
}
